import * as d3 from "d3";
import { IPlayer } from "../types/IPassingNetworkData";
import { IPlayerForVoronoi } from "../types/IVoronoiData";
import { IGamemodelData } from "../components/ClubDetail/Performance/TeamPlayingStyle";


export const drawVoronoi = (
  svg: d3.Selection<SVGSVGElement, unknown, any, undefined>,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  avgPositionPlayers: IPlayerForVoronoi[],
  pitchWidth: number,
  pitchHeight: number
) => {
  const scatterGroup = svg.append("g").attr("id", "scatter-group");
  const playerPositions = avgPositionPlayers.map((player) => [
    xScale(player.average_X),
    yScale(player.average_Y),
  ]);   
  // @ts-ignore
  const delaunay = d3.Delaunay.from(playerPositions);
  const voronoi = delaunay.voronoi([0, 0, pitchWidth, pitchHeight]);
  const voronoiPath = voronoi.render();
    const allVoronoiShapes = scatterGroup
      .append("path")
      .attr("d", voronoiPath)
      .attr("stroke", "white")
      .attr("stroke-dasharray", "5,5")
      .attr("stroke-width", 1)
      .attr("opacity", 0.7);
};

export const drawGameModelVoronoi = (
  svg: d3.Selection<SVGSVGElement, unknown, any, undefined>,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  avgPositionPlayers: IGamemodelData[],
  pitchWidth: number,
  pitchHeight: number
) => {
  const scatterGroup = svg.append("g").attr("id", "scatter-group");

  const playerPositions = avgPositionPlayers.map((player) => [
    xScale(player.avgX),
    yScale(player.avgY),
  ]) as [number, number][];
  

  // Setup Delaunay and Voronoi
  const delaunay = d3.Delaunay.from(playerPositions);
  const voronoi = delaunay.voronoi([0, 0, pitchWidth, pitchHeight]);

  // Color scale based on unique player names
  const colorScale = d3.scaleOrdinal<string, string>()
    .domain(avgPositionPlayers.map(p => p.name))
    .range(d3.schemeCategory10); // You can change to schemeSet3, schemeAccent etc.

  // Draw each Voronoi cell
  avgPositionPlayers.forEach((player, i) => {
    const cell = voronoi.cellPolygon(i);
    if (!cell) return;

  const voronoiPath = voronoi.render();


    scatterGroup.append("path")
      .attr("d", `M${cell.join("L")}Z`)//`M${cell.join("L")}Z`
      .attr("fill", colorScale(player.name))
      .attr("stroke", "black")
      .attr("stroke-dasharray", "5,5")
      .attr("stroke-width", 1)
      .attr("opacity", 0.4);

      // Create tooltip (only once in your main function or globally)
const tooltip = d3
      .select("body")
      .append("div")
      .style("position", "fixed")
      .style("z-index", 999)
      .style("visibility", "hidden")
      .style("background-color", "white")
      .style("color","black")
      .style("border", "1px solid ${theme.secondaryButtonBackground}")
      .style("padding", "8px")
      .style("border-radius", "4px")
      .style("box-shadow", "0px 0px 6px rgba(0, 0, 0, 0.1)");

    // Inside your loop:
    scatterGroup
    .append("circle")
    .attr("cx", xScale(player.avgX))
    .attr("cy", yScale(player.avgY))
    .attr("r", 6)
    .style("fill", "grey")
    .style("cursor","pointer")
    .on("mouseover", (event, d) => {
        tooltip.style("visibility", "visible").text(`${player.name}`);
   
    })
    .on("mousemove", (event) => {
      tooltip.style("left", `${event.clientX - 50}px`).style("top", `${event.clientY - 50}px`);
    })
    .on("mouseout", () => {
      tooltip.style("visibility", "hidden");
    });

  
  });
};

